"use client";

import React, { useState } from "react";
import { Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/gallery_tanker_panama.png",
  alt: "Oil tanker transiting Panama Canal as part of coordinated logistics",
  location: "Panama Coordination Hub"
}, {
  id: 2,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-terminal.jpg?v=xew6h98fobi",
  alt: "Bulk carrier operations coordinated at industrial port",
  location: "Venezuela Network Hub"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/gallery_machinery_spain.png",
  alt: "Strategic port infrastructure within our coordination network",
  location: "Northern Spain Logistics Hub"
}, {
  id: 4,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/venezuela_oil_terminal.webp?v=e22mjny3r4m",
  alt: "Commercial vessel logistics managed at regional terminal",
  location: "Colombia Coordination Point"
}, {
  id: 5,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/gallery_bulk_venezuela.webp?v=w913yp6ydi",
  alt: "Vessel service coordination in offshore Atlantic operations",
  location: "Atlantic Service Sector"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/gallery_port_night_caribbean.png",
  alt: "Round-the-clock brokerage support at key Caribbean hub",
  location: "Caribbean Strategic Hub"
}];
export default function FleetSupportGallery() {
  const [selectedImage, setSelectedImage] = useState<typeof galleryItems[0] | null>(null);
  return <section id="fleet-support-gallery" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 font-serif tracking-tight">
            Maritime Brokerage Gallery
          </h2>
          <div className="h-1 w-20 bg-primary mb-6"></div>
          <p className="text-lg text-muted-foreground">
            Visualizing our global network that coordinates vessels with trusted maritime suppliers and service providers. Our brokerage expertise ensures seamless logistics support for commercial fleets across key strategic regions.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid relative group cursor-pointer overflow-hidden rounded-none border border-border/50 bg-muted/20" onClick={() => setSelectedImage(item)}>
              <img src={item.src} alt={item.alt} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="bg-background/90 backdrop-blur-sm text-foreground p-4 rounded-none shadow-xl transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <Maximize2 className="w-6 h-6" />
                </div>
              </div>

              {}
              <div className="absolute bottom-0 left-0 bg-background/90 backdrop-blur-md border-t border-r border-border/50 px-4 py-2">
                <span className="font-mono text-xs md:text-sm font-medium text-foreground uppercase tracking-widest">
                  {item.location}
                </span>
              </div>
            </div>)}
        </div>
      </div>

      <Dialog open={!!selectedImage} onOpenChange={open => !open && setSelectedImage(null)}>
        <DialogContent className="max-w-6xl w-[95vw] max-h-[95vh] p-1 border border-border bg-background/95 backdrop-blur-xl shadow-2xl rounded-none flex flex-col">
          <DialogHeader className="sr-only">
            <DialogTitle>{selectedImage?.location}</DialogTitle>
            <DialogDescription>{selectedImage?.alt}</DialogDescription>
          </DialogHeader>
          
          {selectedImage && <div className="relative w-full h-full flex flex-col items-center justify-center overflow-hidden bg-muted/10">
              <img src={selectedImage.src} alt={selectedImage.alt} className="w-full h-auto max-h-[80vh] object-contain" />
              <div className="w-full bg-background border-t border-border p-4 flex justify-between items-center">
                <span className="font-mono text-sm font-medium text-foreground uppercase tracking-widest">
                  {selectedImage.location}
                </span>
                <span className="text-sm text-muted-foreground hidden md:inline-block">
                  {selectedImage.alt}
                </span>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}